import { CollectionReference, DocumentReference } from "firebase/firestore"
import { StorageReference, getStorage, ref } from "firebase/storage"

function buildRef(doc: DocumentReference) {
  const collection = doc.parent
  const collectionParent = collection.parent

  const storageParent: StorageReference = collectionParent ? buildRef(collectionParent) : ref(getStorage())

  return ref(ref(storageParent, collection.id), doc.id)
}

function buildRefForCollection(collection: CollectionReference) {
  const collectionParent = collection.parent

  const storageParent: StorageReference = collectionParent ? buildRef(collectionParent) : ref(getStorage())

  return ref(ref(storageParent, collection.id), "images")
}

/**
 * Get a new storage location for an image associated with forDocument
 */
export function getImageUploadRef(forDocument: DocumentReference) {
  const name = [...Array(24)].map(() => Math.random().toString(36)[2]).join("")

  return ref(buildRef(forDocument), name)
}

/**
 * Get a new storage location for an image associated with collection
 */
export function getImageUploadRefForCollection(forCollection: CollectionReference) {
  const name = [...Array(24)].map(() => Math.random().toString(36)[2]).join("")

  return ref(buildRefForCollection(forCollection), name)
}
